import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Header.css';
import logo from '../assets/logo12.png';
import { FaHome } from "react-icons/fa";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null); // 'about' | 'services' | 'projects' | null
  const [subDropdown, setSubDropdown] = useState(null);   // 'engineering' | 'auxiliary' | null
  
  // Logic for Show/Hide on Scroll
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const dropdownRef = useRef(null);
  const isMobile = window.innerWidth <= 1024;

  useEffect(() => {
    const controlHeader = () => {
      if (typeof window !== 'undefined') {
        if (window.scrollY > lastScrollY && window.scrollY > 100) {
          // Scrolling DOWN - Hide Header
          setIsVisible(false);
        } else {
          // Scrolling UP - Show Header
          setIsVisible(true);
        }
        setLastScrollY(window.scrollY);
      }
    };

    window.addEventListener('scroll', controlHeader);
    return () => window.removeEventListener('scroll', controlHeader);
  }, [lastScrollY]);

  // Handle outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdown(null);
        setSubDropdown(null);
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLinkClick = () => {
    setIsOpen(false);
    setOpenDropdown(null);
    setSubDropdown(null);
  };

  const toggleDropdown = (dropdown) => {
    setOpenDropdown((prev) => (prev === dropdown ? null : dropdown));
    setSubDropdown(null);
  };

  const toggleSubDropdown = (type) => {
    if (isMobile) {
      setSubDropdown((prev) => (prev === type ? null : type));
    }
  };

  return (
    <header 
      className={`header ${!isVisible ? 'header-hidden' : ''}`} 
      ref={dropdownRef}
    >
      <div className="logo-container">
        <img src={logo} alt="Logo" className="logo" />
      </div>

      <nav className={`nav ${isOpen ? 'open' : ''}`}>
        <ul>
          <li>
            <Link to="/" onClick={handleLinkClick}>
              <FaHome size={18} />
            </Link>
          </li>

          {/* ===== ABOUT / ACUME DROPDOWN ===== */}
          <li
            className="services-dropdown"
            onClick={() => toggleDropdown('about')}
            style={{ userSelect: 'none', cursor: 'pointer' }}
          >
            <span className="dropdown-toggle">
              Acume <span style={{ marginLeft: 6 }}>{openDropdown === 'about' ? '▲' : '▼'}</span>
            </span>
            {openDropdown === 'about' && (
              <ul className="services-dropdown-menu" onClick={(e) => e.stopPropagation()}>
                <li><Link to="/aboutus" onClick={handleLinkClick}>About Us</Link></li>
                <li><Link to="/certificatepg" onClick={handleLinkClick}>Certification</Link></li>
                <li><Link to="/vtex" onClick={handleLinkClick}>WETEX</Link></li>
              </ul>
            )}
          </li>

          {/* ===== SERVICES DROPDOWN ===== */}
          <li
            className="services-dropdown"
            onClick={() => toggleDropdown('services')}
            style={{ userSelect: 'none', cursor: 'pointer' }}
          >
            <span className="dropdown-toggle">
              Services <span style={{ marginLeft: 6 }}>{openDropdown === 'services' ? '▲' : '▼'}</span>
            </span>
            {openDropdown === 'services' && (
              <ul className="services-dropdown-menu" onClick={(e) => e.stopPropagation()}>
                <li><Link to="/services/epcpage" onClick={handleLinkClick}>EPC Contracting</Link></li>
               

                <li
                  className="nested-dropdown"
                  onClick={() => toggleSubDropdown('engineering')}
                  onMouseEnter={() => !isMobile && setSubDropdown('engineering')}
                  onMouseLeave={() => !isMobile && setSubDropdown(null)}
                >
                  <span>Engineering ▸</span>
                  {subDropdown === 'engineering' && (
                    <ul className={`nested-dropdown-menu ${isMobile ? 'mobile-dropdown' : ''}`}>
                      <li><Link to="/services/designpg" onClick={handleLinkClick}>Design</Link></li>
                      <li><Link to="/services/elecinstallatingpg" onClick={handleLinkClick}>Electrical Installation</Link></li>
                      <li><Link to="/services/testingcommissioningpg" onClick={handleLinkClick}>Testing & Commissioning</Link></li>
                    </ul>
                  )}
                </li>

                <li><Link to="/services/Renewablepg" onClick={handleLinkClick}>Renewable Energy</Link></li>
                <li><Link to="/services/operationmaintenancepg" onClick={handleLinkClick}>Operation & Maintenance</Link></li>
                 <li><Link to="/services/cablepg" onClick={handleLinkClick}>Cable Laying and Termination</Link></li>
                <li><Link to="/services/equipmentrentalpg" onClick={handleLinkClick}>Equipment Rental</Link></li>

                <li
                  className="nested-dropdown"
                  onClick={() => toggleSubDropdown('auxiliary')}
                  onMouseEnter={() => !isMobile && setSubDropdown('auxiliary')}
                  onMouseLeave={() => !isMobile && setSubDropdown(null)}
                >
                  <span>Auxiliary Services ▸</span>
                  {subDropdown === 'auxiliary' && (
                    <ul className={`nested-dropdown-menu ${isMobile ? 'mobile-dropdown' : ''}`}>
                      <li><Link to="/services/oilfiltrationpg" onClick={handleLinkClick}>Transformer Oil Filtration</Link></li>
                      <li><Link to="/services/manpowerpg" onClick={handleLinkClick}>Manpower</Link></li>
                      <li><Link to="/services/scadapg" onClick={handleLinkClick}>SCADA</Link></li>
                    </ul>
                  )}
                </li>
              </ul>
            )}
          </li>

          {/* ===== PROJECTS DROPDOWN ===== */}
          <li
            className="services-dropdown"
            onClick={() => toggleDropdown('projects')}
            style={{ userSelect: 'none', cursor: 'pointer' }}
          >
            <span className="dropdown-toggle">
              <Link to="/projectpg" onClick={handleLinkClick} style={{color: 'inherit', textDecoration: 'none'}}>Projects</Link>
              <span style={{ marginLeft: 6 }}>{openDropdown === 'projects' ? '▲' : '▼'}</span>
            </span>
            {openDropdown === 'projects' && (
              <ul className="services-dropdown-menu" onClick={(e) => e.stopPropagation()}>
                <li><Link to="/projects/ongoing" onClick={handleLinkClick}>Ongoing Projects</Link></li>
                <li><Link to="/projects/completed" onClick={handleLinkClick}>Completed Projects</Link></li>
                <li><Link to="/projects/appreciationpg" onClick={handleLinkClick}>Appreciation Certification</Link></li>
              </ul>
            )}
          </li>

          <li><Link to="/clientpg" onClick={handleLinkClick}>Our Clients</Link></li>
          <li><Link to="/Careerspg" onClick={handleLinkClick}>Careers</Link></li>
          <li><Link to="/contactpg" onClick={handleLinkClick}>Contact Us</Link></li>
        </ul>
      </nav>

      <button
        className={`menu-toggle ${isOpen ? 'open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
    </header>
  );
};

export default Header;